import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "cms-imprint-page",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  id: "exampleModalLabel",
  class: "modal-title"
}, null, -1)
const _hoisted_6 = {
  "aria-label": "Close",
  class: "close-btn",
  href: "#",
  "data-bs-dismiss": "modal",
  type: "button"
}
const _hoisted_7 = { class: "icon close-icon" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["innerHTML"]

import {toRefs} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImprintModal',
  props: {
    syncImprintPage: {
        type: String,
        required: true
    }
},
  setup(__props) {

const props = __props;


const {syncImprintPage} = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_vue_feather, {
                size: "18px",
                stroke: "#878787",
                type: "x"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "row",
            innerHTML: _unref(syncImprintPage)
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}
}

})